import { Injectable } from '@angular/core';
import { ContextService } from './ctx.service';

@Injectable({
  providedIn: 'root'
})
export class UrlService {

  constructor(
    private ctx: ContextService
  ) { }

  getApiBaseUrl(): string {
    return 'api/1.0/';
  }

  getIdentifyUserUrls(): string {
    const environment = this.ctx.environment;
    let url: string;
    
    switch (environment) {
      case 'ic':
        url = 'https://areadeclientes.digital.pre.mapfredigitalhealth.com/release/client-area/health-resume?redirect=appointments%2Frequest-s1';
        break;
      case 'int':
        url = 'https://areadeclientes.digital.pre.mapfredigitalhealth.com/release/client-area/health-resume?redirect=appointments%2Frequest-s1';
        break;
      case 'pre':
        url = 'https://areadeclientes.digital.pre.mapfredigitalhealth.com/release/client-area/health-resume?redirect=appointments%2Frequest-s1';
        break;
      case 'pro':
      case 'pro-buscadores':
        url = 'https://tarjetadesalud.go.link/8DvMn';
        break;
      default:
        url = 'https://areadeclientes.digital.pre.mapfredigitalhealth.com/release/client-area/health-resume?redirect=appointments%2Frequest-s1';
        break;
    }

    return url;
  }

}

